import { render } from "./ChooseSubNotificationModal.vue?vue&type=template&id=07d8e3b8&scoped=true"
import script from "./ChooseSubNotificationModal.vue?vue&type=script&lang=js"
export * from "./ChooseSubNotificationModal.vue?vue&type=script&lang=js"

import "./ChooseSubNotificationModal.vue?vue&type=style&index=0&id=07d8e3b8&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d8e3b8"]])

export default __exports__